import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'divider',
  name: '分割线',
  icon: '线',
  group: '辅助组件',
  description: '分隔相邻内容区块',
  defaultProps: {
    thickness: 1,
    lineStyle: 'SOLID'
  }
}
